import * as T from 'io-ts';
const AddPlayerRequestT = T.type({
    org_uid: T.string,
});
const AddPlayerOkResponseT = T.type({ status: T.literal('Ok') });
const AddPlayerFullResponseT = T.type({ status: T.literal('Full') });
const AddPlayerClosedResponseT = T.type({
    status: T.literal('Closed'),
    message: T.string,
});
const AddPlayerResponseT = T.union([AddPlayerOkResponseT, AddPlayerClosedResponseT, AddPlayerFullResponseT]);
export { AddPlayerRequestT, AddPlayerResponseT };
